module.exports = __webpack_public_path__ + "img/pdf_logo.de71f9b3.png";